import { FC } from 'react';
import styles from '../UserInfo.module.scss';

interface UserStatsProps {
  membersCount: number | null;
  maxMemberCount?: number;
  challengesCount?: number;
}

export const UserStats: FC<UserStatsProps> = ({
  membersCount,
  maxMemberCount,
  challengesCount,
}) => {
  return (
    <div className={styles.container_item}>
      {membersCount != null && (
        <div className={styles.mobileMemberCount}>{membersCount} members</div>
      )}
      <div className={styles.info}>
        <span className={styles.statLabel}>Challenges:</span>{' '}
        <span className={styles.statValue}>{challengesCount || 0}</span>
      </div>
      {membersCount != null && (
        <div className={styles.info}>
          <span className={styles.statLabel}>Members:</span>{' '}
          <span className={styles.statValue}>{membersCount}</span>
        </div>
      )}
      {maxMemberCount != null && (
        <div className={styles.info}>
          <span className={styles.statLabel}>Circle Size:</span>{' '}
          <span className={styles.statValue}>{maxMemberCount}</span>
        </div>
      )}
    </div>
  );
};
